var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('automation-tab',_vm._b({attrs:{"buttons":_vm.options.buttons},on:{"update:buttons":function($event){return _vm.$set(_vm.options, "buttons", $event)}}},'automation-tab',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }